(function() { window.GUID_07d4d5fa_be81_4a67_851f_f595c4810ecf = { getGuid: function() { return "07d4d5fa-be81-4a67-851f-f595c4810ecf"; } }; })();


//# sourceMappingURL=ifixed-header.js.map
